import { ProductSliderProps, ProductSliderEditorProps } from './ProductSlider.types';

/**
 * 기존 데이터 형식을 새로운 형식으로 변환
 * 
 * @param originalProps 기존 컴포넌트의 props
 * @returns 변환된 새로운 컴포넌트용 props
 */
export function adaptProductSliderProps(originalProps: any): ProductSliderProps {
  // 기본값 설정 (빈 객체로 초기화)
  const originalContent = originalProps?.content || {};
  const originalData = originalProps?.data || {};
  const originalComponentProps = originalProps?.componentProps || {};
  
  // 스타일 병합 (깊은 복사로 병합)
  const style = {
    ...(originalProps?.style || {}),
    ...(originalComponentProps?.style || {})
  };
  
  // 인라인 스타일과 CSS 클래스 통합
  if (originalProps.defaultStyle) {
    Object.assign(style, originalProps.defaultStyle);
  }

  // className 설정
  const className = originalProps?.className || originalComponentProps?.className || '';

  // 슬라이더 제목
  const sliderTitle = originalComponentProps?.sliderTitle || 
                      originalContent?.sliderTitle || 
                      '';

  // 슬라이더 제목 표시 여부
  const showTitle = originalComponentProps?.showTitle !== undefined
    ? originalComponentProps.showTitle
    : originalContent?.showTitle !== undefined
      ? originalContent.showTitle
      : true;

  // 제목 스타일 속성
  const titleFontSize = originalComponentProps?.titleFontSize ||
                        originalContent?.titleFontSize ||
                        '18px';
  
  const titleFontWeight = originalComponentProps?.titleFontWeight ||
                          originalContent?.titleFontWeight ||
                          '600';
  
  const titleColor = originalComponentProps?.titleColor ||
                     originalContent?.titleColor ||
                     '#333';

  // 슬라이드 속성
  const itemsPerSlide = originalComponentProps?.itemsPerSlide ||
                        originalContent?.itemsPerSlide ||
                        4;
  
  const autoSlide = originalComponentProps?.autoSlide !== undefined
    ? originalComponentProps.autoSlide
    : originalContent?.autoSlide !== undefined
      ? originalContent.autoSlide
      : true;
  
  const autoSlideInterval = originalComponentProps?.autoSlideInterval ||
                           originalContent?.autoSlideInterval ||
                           3000;

  // 필터링 속성
  const productIds = originalComponentProps?.productIds ||
                    originalContent?.productIds ||
                    '';
  
  const include_product_ids = originalComponentProps?.include_product_ids ||
                             originalContent?.include_product_ids ||
                             productIds || '';
  
  const exclude_product_ids = originalComponentProps?.exclude_product_ids ||
                             originalContent?.exclude_product_ids ||
                             '';
  
  const include_category_ids = originalComponentProps?.include_category_ids ||
                              originalContent?.include_category_ids ||
                              '';
  
  const exclude_category_ids = originalComponentProps?.exclude_category_ids ||
                              originalContent?.exclude_category_ids ||
                              '';

  
  
  // 재고 표시 여부
  const showStock = originalComponentProps?.showStock !== undefined
    ? originalComponentProps.showStock
    : originalContent?.showStock !== undefined
      ? originalContent.showStock
      : false;

  // 변환된 props 반환
  const adaptedProps: ProductSliderProps = {
    content: { 
      ...originalContent,
      sliderTitle,
      showTitle,
      titleFontSize,
      titleFontWeight,
      titleColor,
      itemsPerSlide,
      autoSlide,
      autoSlideInterval,
      productIds,
      include_product_ids,
      exclude_product_ids,
      include_category_ids,
      exclude_category_ids,
      showStock
    },
    style,
    className,
    data: originalData,
    componentProps: {
      ...originalComponentProps,
      sliderTitle,
      showTitle,
      titleFontSize,
      titleFontWeight,
      titleColor,
      itemsPerSlide,
      autoSlide,
      autoSlideInterval,
      productIds,
      include_product_ids,
      exclude_product_ids,
      include_category_ids,
      exclude_category_ids,
      showStock
    },
    id: originalProps?.id || '',
  };

  // 원본 props의 모든 속성 중 이미 처리한 속성 제외하고 나머지 복사
  const excludeKeys = ['content', 'style', 'className', 'data', 'componentProps', 'id', 'defaultStyle'];
  
  Object.keys(originalProps).forEach(key => {
    if (!excludeKeys.includes(key)) {
      adaptedProps[key] = originalProps[key];
    }
  });

  return adaptedProps;
}

/**
 * 에디터용 데이터 형식 변환
 * 
 * @param originalProps 기존 컴포넌트의 props
 * @returns 변환된 에디터 컴포넌트용 props
 */
export function adaptProductSliderEditorProps(originalProps: any): ProductSliderEditorProps {
  // 기본 props 변환 사용
  const adaptedProps = adaptProductSliderProps(originalProps) as ProductSliderProps;
  
  // 에디터 관련 추가 props
  return {
    ...adaptedProps,
    isSelected: originalProps.isSelected || false,
    isPreview: originalProps.isPreview || false,
    viewMode: originalProps.viewMode || 'pc',
    updateComponent: originalProps.updateComponent || (() => {})
  };
} 